export default __webpack_public_path__ + "static/media/guia-3-2.3e00252c.svg";